/**
 * 账号密码登录（`POST /system/auth/login`）失败时要不要给专门文案。
 *
 * 业主门户账号（user_type=owner）只能登录 Nova Owner；拿它登员工 web，后端在密码校验
 * 通过后回 401 `AUTH_OWNER_ACCOUNT`（main-api spec 2026-10-09-owner-portal-accounts）。
 * 登录请求的 401 不会被 axios 拦截器翻译（拦截器对登录 401 直接 reject 原始 axios
 * error），码在 `err.response.data.error`（小写，历史契约）/ `error_code`（大写）——
 * `extractApiErrorCode` 两种都认。
 */
import { extractApiErrorCode } from '@/utils/apiError'

export const OWNER_ACCOUNT_LOGIN_CODE = 'AUTH_OWNER_ACCOUNT'

export function isOwnerAccountLoginError(err: unknown): boolean {
  return extractApiErrorCode(err) === OWNER_ACCOUNT_LOGIN_CODE
}
